import { isNil } from 'lodash';
import { useCallback } from 'react';
import { useCardNavigationContext } from '@shared/scenes/cards/navigation';
import { API } from '@shared/types/api';
import { useNavigator } from '@shared/util/navigation';

export interface OpenEntityOptions {
  entityId: string;
  entityViewTemplateId?: string | null;
  entityVariables?: API.ListWorkflowEntitiesQueryVariables;
  backTooltip?: string;
}

export type OpenEntityHandler = (options: OpenEntityOptions) => void;

export function useOpenEntityById(
  channelSlug: string,
  workflowTemplateId: string,
): OpenEntityHandler {
  const { navigate } = useNavigator();
  const { addStackItem } = useCardNavigationContext();

  return useCallback(
    (options: OpenEntityOptions) => {
      const { entityId, entityVariables, entityViewTemplateId, backTooltip } = options;

      const menu = document.querySelector('[aria-haspopup="menu"][aria-expanded="true"]');
      if (!isNil(menu)) {
        return;
      }

      addStackItem({
        entityId,
        channelSlug,
        entityVariables,
        backTooltip,
      });

      navigate('CardUpdate', {
        cardId: entityId,
        channelSlug,
        workflowTemplateId,
        templateSlug: entityViewTemplateId ?? undefined,
      });
    },
    [addStackItem, navigate, channelSlug, workflowTemplateId],
  );
}
